import styled from '@emotion/styled';
import { FC } from 'react';
import { StyledInput } from '../styles';
import { FormInputProps } from '../utils';

type InputProps = {
  hasError?: boolean;
  showBoldPlaceHolder?: boolean;
};

const Input = styled(StyledInput)<InputProps>`
  width: 100%;

  &.MuiOutlinedInput-root {
    border-color: ${({ hasError }) =>
      hasError ? 'var(--color-i-red)' : 'var(--color-divider)'};
  }

  ${({ showBoldPlaceHolder }) =>
    showBoldPlaceHolder &&
    `
    input::placeholder {
      opacity: 1;
      font-weight: 600;
      color: var(--color-text-secondary);
    }
  `}
`;

const TextInput: FC<FormInputProps> = ({
  value,
  onChange,
  hasError,
  placeholder = '',
  showBoldPlaceHolder = false,
  style = {}
}) => {
  return (
    <>
      <Input
        style={style}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        hasError={hasError && !value}
        showBoldPlaceHolder
      />
    </>
  );
};

export default TextInput;
